@use '@design/design-tokens/typography/typography' as *;

.footerRoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: var(--surface-default);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  &.hasScroll {
    border-bottom-right-radius: 0;
  }
}

.footerText {
  @include typography-v2-body-xs;
  color: var(--text-default);
}

.styledButtonLink {
  [data-button-link-label] {
    @include typography-v2-ui-xs;
  }
}
